function FourOhFour() {
    return <h1  class="fourohfour">404</h1>;
};

export default FourOhFour;